import { PAGE_TYPE } from '../../constants';
import { buildPagePerStoreBreadcrumbs } from '../../structured-data/build-pps-breadcrumbs';
import { buildPagePerStoreStructuredFAQ } from '../../structured-data/build-pps-structured-faq';

/**
 * Generates the description for the Home Services detail page.
 *
 * @param {Object} params - Parameters for generating the description.
 * @param {string} params.storeName - The name of the store.
 * @param {string} params.storeServicesPhone - The phone number for store services.
 * @returns {string} The generated description for the Home Services detail page.
 */
export const generateHomeServicesDesc = ({ storeName, storeServicesPhone }) => {
  if (!storeName && !storeServicesPhone) {
    return 'The Home Depot';
  }

  return `Visit your ${storeName} Home Depot to schedule a free consultation for installation and repair services.`
    + ` Call us at ${storeServicesPhone} today!`;
};

/**
 * Generates an array of schema objects for use in generating Home Services structured data script tags.
 * Each schema object will have both a `content` property (the JSON-LD string) and an `id`.
 * If either property is missing, that schema object will be ignored downstream.
 *
 * If `emtSchema` is provided, it will be used as the only schema in the array.
 * Otherwise, default schemas for breadcrumbs and FAQ are generated using the provided store and EMT content data.
 *
 * @param {Object} params - Parameters for generating schemas.
 * @param {string} [params.emtSchema] - A string containing the JSON-LD schema content for Home Services.
 * @param {Object} params.storeInfo - The store information object.
 * @param {Object} params.emtContentFileData - The EMT content file data for FAQ schema generation.
 * @returns {Array} An array of schema objects, each with a `content` (string) and `id` (string).
 */
export const getHomeServicesSchemas = ({ emtContentFileData, emtSchema, storeInfo }) => {
  if (emtSchema) {
    return [{ content: emtSchema, id: 'homeServicesStructuredData' }];
  }
  return [
    {
      content: buildPagePerStoreBreadcrumbs({
        storeInfo,
        departmentName: 'Home Services',
        departmentID: PAGE_TYPE.HOME_SERVICES
      }),
      id: 'homeServicesStructuredBreadcrumb'
    },
    {
      content: buildPagePerStoreStructuredFAQ(emtContentFileData),
      id: 'homeServicesStructuredFAQData'
    }
  ];
};